import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import index from '@/layout/index.vue'
const routes: Array<RouteRecordRaw> = [
    // {
    //     path: '/',
    //     name: 'redirect',
    //     redirect: '/',
    // },
    // {
    //     path: '/',
    //     name: 'home',
    //     component: () => import("@/pages/home/index.vue")
    // },
    // {
    //     path: '/template',
    //     name: 'template',
    //     component: () => import("@/pages/template/index.vue")
    // },
    {
        path: '/',
        name: 'indexPage',
        component: index,
        children: [
            {
                path: '/',
                name: 'home',
                component: () => import("@/pages/home/index.vue")
            },//首页
            {
                path:'/template',
                name:'template',
                component:()=> import("@/pages/template/index.vue")
            }//公共模板页
        ]
    },
]
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
